<template>
  <div style="padding:14px 10px">
    <!-- 面包屑导航 -->
    <div class="cur_route">{{ $route.name }}</div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/index' }">Dashboard</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.name" placeholder="Operator name" clearable></el-input>
      </el-form-item>
      <!-- <el-select size="small" v-model="params.country" clearable placeholder="Country"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in countryList" :key="item.name" :label="item.name" :value="item.name">
        </el-option>
      </el-select> -->
      <el-form-item label="">
        <el-cascader :options="country_business" size="small"
          :props="{ checkStrictly: true, value: 'name', label: 'name', expandTrigger: 'hover' }" clearable
          placeholder="Country/Business" @change="cascaderChange" style="position:relative;right:2px">
        </el-cascader>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.callback_time" type="daterange" size="small" value-format="yyyy-MM-dd"
          align="right" unlink-panels start-placeholder="Start date" end-placeholder="End date"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">Add</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 1612px;">
      <el-table-column prop="id" label="ID" width="70" align="center">
      </el-table-column>
      <el-table-column prop="name" label="Name" width="100" align="center">
      </el-table-column>
      <el-table-column prop="country" label="Country" width="100">
      </el-table-column>
      <el-table-column prop="color" label="Color" width="70">
        <template slot-scope="scope">
          <div :style="{ background: scope.row.color, width: '30px', height: '30px', borderRadius: '3px' }"></div>
        </template>
      </el-table-column>
      <el-table-column prop="numbers" label="Cards" width="240">
      </el-table-column>
      <el-table-column prop="reserved_num" label="Recharge nums" width="130" align="center">
      </el-table-column>
      <el-table-column prop="sum_amount_reserved" label="Recharge amount" width="130" align="center">
      </el-table-column>
      <el-table-column prop="reserved_num" label="Recharge rate" width="130" align="center">
        <template slot-scope="scope">
          <div>{{ numRate(scope.row.country, scope.row.reserved_num, 'reserved') }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="transaction_num" label="Withdraw nums" width="130" align="center">
      </el-table-column>
      <el-table-column prop="sum_amount_transaction" label="Withdraw amount" width="130" align="center">
      </el-table-column>
      <el-table-column prop="transaction_num" label="Withdraw rate" width="140" align="center">
        <template slot-scope="scope">
          <div>{{ numRate(scope.row.country, scope.row.transaction_num, 'transaction') }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="save_time" label="Save time" width="140">
        <template slot-scope="scope">
          <div>{{ scope.row.save_time | timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Action" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Edit界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="Name" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="Operator name" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Country" prop="country">
          <el-select size="small" v-model="editForm.country" clearable placeholder="Select country">
            <el-option v-for="item in countryList" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Color" prop="color">
          <el-color-picker v-model="editForm.color"></el-color-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCountryBusiness,
  operatorList,
  operatorSave,
  countryList
} from '../../api/apiFun'
import {
  math
} from '@/utils/math'
import {
  timestampToTime,
  currentDate, cascaderChange,
} from '@/utils/util';
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      countryList: [],
      loading: false, //是显示加载
      editFormVisible: false, //控制Edit页面显示与隐藏
      title: 'Add',
      editForm: {
        id: '',
        name: '',
        country: '',
        color: '',
      },
      pickerOptions: {
        shortcuts: [{
          text: 'Today',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last week',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last month',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      // rules 表单验证
      rules: {
        name: [{
          required: true,
          message: 'Please enter the operator name',
          trigger: 'blur'
        }],
        country: [{
          required: true,
          message: 'Please select country',
          trigger: 'blur'
        }],
        color: [{
          required: true,
          message: 'Please select color',
          trigger: 'blur'
        }],
      },
      params: {
        name: '',
        country: '',
        callback_time: [currentDate(), currentDate()],
        business_name: ''
      },
      listData: [],
      operator_country: [],
      country_business: [],
    }
  },
  components: {
    Pagination
  },
  filters: {
    timestampToTime: function (timestamp) {
      return timestampToTime(timestamp)
    }
  },
  created() {
    this.getCountryList()
    this.getCountryBusiness()
    this.getdata(this.params)
  },
  methods: {
    cascaderChange(value) {
      var cascader = cascaderChange(value)
      this.params.country = cascader[0]
      this.params.business_name = cascader[1]
    },
    getCountryBusiness() {
      getCountryBusiness().then(res => {
        if (res.code == 400) {
          this.$message({
            state: 'info',
            message: res.msg
          })
        } else {
          this.country_business = res.datas;
        }
      }).catch(err => {
        this.$message.error('Failed to obtain business list, please try again later!')
      })
    },
    numRate(country, num, type) {
      var rate = 0;
      if (type == 'reserved') {
        this.operator_country.forEach(item => {
          if (item.country == country) {
            if (item.total_reserved_num != 0) {
              var d = math.divide(num, item.total_reserved_num).toFixed(3)
              rate = math.multiply(d, 100);
            }
          }
        });
      }
      if (type == 'transaction') {
        this.operator_country.forEach(item => {
          if (item.country == country) {
            if (item.total_reserved_num != 0) {
              var d = math.divide(num, item.total_transaction_num).toFixed(3)
              rate = math.multiply(d, 100);
            }
          }
        });
      }
      return rate + '%';
    },
    getCountryList() {
      countryList().then(res => {
        if (res.code == 400) {
          this.$message({
            state: 'info',
            message: res.msg
          })
        } else {
          this.countryList = res.datas
        }
      }).catch(err => {
        this.$message.error('Failed to get country, please try again later!')
      })
    },
    // 获取Operator list
    getdata(parameter) {
      this.loading = true
      operatorList(parameter).then(res => {
        this.loading = false
        if (res.code == 400) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.datas.list
          this.operator_country = res.datas.operator_country
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('Failed to get operator list, please try again later!')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.params.page = parm.currentPage
      this.params.limit = parm.pageSize
      this.getdata(this.params)
    },
    // Search事件
    search() {
      this.params.page = 1
      this.getdata(this.params)
    },
    //显示Edit界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = 'Edit'
        this.editForm.id = row.id
        this.editForm.name = row.name
        this.editForm.country = row.country
        this.editForm.color = row.color
      } else {
        this.title = 'Add'
        this.editForm.id = ''
        this.editForm.name = ''
        this.editForm.country = ''
        this.editForm.color = ''
      }
    },
    // Edit、增加页面Save方法
    submitForm(editData) {
      this.loading = true
      this.$refs[editData].validate(valid => {
        if (valid) {
          operatorSave(this.editForm).then(res => {
            this.editFormVisible = false
            this.loading = false
            if (res.code == 200) {
              this.getdata(this.params)
              this.$message({
                type: 'success',
                message: 'Saved successfully'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('Saving failed, please try again later!')
          })
        } else {
          this.loading = false
          return false
        }
      })
    },
    // closeEdit、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') { }
    },
  }
}

</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/operator/operator_list.vue